var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 87,
    viewBox: "0 0 88 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 87,
    height: 86,
    rx: 16.5,
    fill: "#F0F6FF",
    stroke: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_20340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.9897 29.3091C60.9897 32.3386 58.5339 34.7944 55.5048 34.7944C52.4753 34.7944 50.0195 32.3386 50.0195 29.3091C50.0195 26.28 52.4753 23.8242 55.5048 23.8242C58.5339 23.8242 60.9897 26.28 60.9897 29.3091Z",
    fill: "#1A5298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0093 36.4142L43.4059 32.5102V25.8491C43.4059 23.1911 41.2622 21 38.5579 21H25.8491C23.1585 21 21 23.178 21 25.8491V33.6151C21 36.2799 23.1506 38.4638 25.8491 38.4638H44.9124C45.9627 38.4638 46.593 37.2896 46.0093 36.4142ZM32.1662 33.5217H28.0038C27.2938 33.5217 26.683 32.9754 26.6501 32.2661C26.6154 31.5088 27.2176 30.8849 27.967 30.8849H32.2037C32.9518 30.8849 33.5553 31.5088 33.5203 32.2658C33.4877 32.9754 32.8766 33.5217 32.1662 33.5217ZM36.4399 28.5788H28.0045C27.2948 28.5788 26.6844 28.034 26.6504 27.3254C26.614 26.568 27.2169 25.9421 27.967 25.9421H36.4025C37.1128 25.9421 37.7239 26.4884 37.7566 27.198C37.7916 27.955 37.188 28.5788 36.4399 28.5788Z",
    fill: "#1A5298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2379 53.7088C25.5597 53.7284 21 58.4161 21 64.0943V64.3834C21 65.2764 21.7237 66.0001 22.6167 66.0001H39.9315C40.8245 66.0001 41.5482 65.2764 41.5482 64.3834V63.9827C41.5482 58.2963 36.9288 53.6889 31.2379 53.7088Z",
    fill: "#1A5298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7438 47.2391C37.7438 50.8121 34.8476 53.7087 31.2743 53.7087C27.7013 53.7087 24.8047 50.8121 24.8047 47.2391C24.8047 43.6661 27.7013 40.7695 31.2743 40.7695C34.8476 40.7695 37.7438 43.6661 37.7438 47.2391Z",
    fill: "#1A5298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8241 42.1817H47.1836C47.6742 38.022 51.2118 34.7944 55.5044 34.7944C59.7959 34.7944 63.3335 38.022 63.8241 42.1817Z",
    fill: "#1A5298"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6828 44.9062C65.411 44.9062 66.0012 45.4964 66.0012 46.2246V61.8578C66.0012 62.6066 65.3763 63.2105 64.6186 63.1745C63.9103 63.1408 63.3644 62.53 63.3644 61.82V60.3513H43.6656C42.7795 57.3349 40.8205 54.772 38.2305 53.1099C39.5715 51.5235 40.3821 49.4738 40.3821 47.2388C40.3821 46.433 40.2763 45.6516 40.0786 44.9062H64.6828Z",
    fill: "#1A5298"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_20340"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(21 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewIcon);
export default __webpack_public_path__ + "static/media/interview_icon.eba8cd329a906404205681b21b6dc398.svg";
export { ForwardRef as ReactComponent };